// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2368": "45ff6a86fff4","5981": "9200fc8d30ac","8153": "ecd0595f9096","9772": "f056bf1ce587",}[chunkId] + ".css"
}